import { PricingEvent as e } from "./PricingEvent.mjs";
import { z as t } from "zod";
//#region src/verticals/pricing/PricingEventPayloads.ts
var n = t.enum([
	"EGP",
	"USD",
	"EUR"
]), r = t.object({
	ruleId: t.string().uuid(),
	listingId: t.string().uuid(),
	ruleType: t.string()
}), i = t.object({
	ruleId: t.string().uuid(),
	listingId: t.string().uuid()
}), a = t.object({ ruleId: t.string().uuid() }), o = t.object({
	listingId: t.string().uuid(),
	date: t.string().datetime(),
	price: t.number().positive(),
	currency: n
}), s = {
	[e.RuleCreated]: r,
	[e.RuleApplied]: i,
	[e.RuleDeleted]: a,
	[e.OverrideApplied]: o
};
//#endregion
export { s as PricingEventSchemas };
